import { render, staticRenderFns } from "./close-modal-button.vue?vue&type=template&id=a30219a4&scoped=true"
import script from "./close-modal-button.vue?vue&type=script&lang=js"
export * from "./close-modal-button.vue?vue&type=script&lang=js"
import style0 from "./close-modal-button.vue?vue&type=style&index=0&id=a30219a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30219a4",
  null
  
)

export default component.exports